import { render, staticRenderFns } from "./BaseModalNotification.vue?vue&type=template&id=e2df86a4&scoped=true&"
import script from "./BaseModalNotification.vue?vue&type=script&lang=js&"
export * from "./BaseModalNotification.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalNotification.vue?vue&type=style&index=0&id=e2df86a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2df86a4",
  null
  
)

export default component.exports